import { UIHeading2 } from '@cian/ui-kit';
import { plural } from '@cian/utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { QUESTIONS_COUNT_PLURAL, REVIEWS_COUNT_PLURAL } from '../../constants/reviews';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';

export const TabsHeaderContainer = (): React.JSX.Element => {
  const { reviewsCount, questionsCount } = useSelector(getNewbuildingInfo);

  return (
    <UIHeading2>
      {reviewsCount}&nbsp;{plural(reviewsCount, REVIEWS_COUNT_PLURAL)} и&nbsp;{questionsCount}&nbsp;
      {plural(questionsCount, QUESTIONS_COUNT_PLURAL)}
    </UIHeading2>
  );
};
